/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit } from '@angular/core';
import { AppDataService } from '../../../services/app-data.service';
import { CompanyService } from '../../../services/company.service';
import { TranslationService } from '../../../services/translation.service';

declare var $: any;
declare var Swal: any

@Component({
  selector: 'user-interaction-modal',
  templateUrl: 'user-interaction-modal.html',
})
export class UserInteractionModal implements OnInit {

  public canAskContact = false;
  public canChat = false;
  public canVideo = false;
  public canKick = false;

  public user;
  public images = []
  public hasKey = false;
  public ngOnInit(): any {
  }

  public makeContact() {
    if (this._appData.instagramUser.company === this.user.company) {
      this.sendMessage();
    } else {
      this.askContact(0);
    }
  }

  public kick() {
    Swal.fire({
      title: 'Remover usuário da sala',
      text: 'Você deseja remover ' + this.user.full_name + ' da sala?',
      confirmButtonText: 'SIM',
      cancelButtonText: 'Não',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event, this._appData.instagramUser, { uid: this.user.uid, full_name: this.user.full_name }, 'Remoção', this._appData.instagramUser.full_name + ' te removeu da sala.', 'kick', null, null)
      }
    })
  }
  public closeModal() {
    $('#userInteractionModal').modal('hide')
  }
  public askContact(skill) {
    if (isNaN(this._appData.instagramUser.uid)) {
      let askId = this._appData.friendOnEvent;
      let name = this._appData.instagramUser.full_name;
      Swal.fire({
        title: this.translate.instant('USER_INTERACTION_2'),
        text: this.translate.instant('USER_INTERACTION_3') + name + this.translate.instant('USER_INTERACTION_4'),
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText: this.translate.instant('NO'),
        showCancelButton: true,
        showCloseButton: true,
        preConfirm: () => {
          this._companyService.sendNotificationToSomeoneElse(this._appData.event, this._appData.instagramUser, askId, this.translate.instant('USER_INTERACTION_2'), this._appData.instagramUser.full_name + this.translate.instant('USER_INTERACTION_5'), 'askContact', skill, null)
        }

      })

    }
    else {
      Swal.fire(this.translate.instant('CHECKVIDEO_COMPONENT_26'), this.translate.instant('CHECKVIDEO_COMPONENT_27'))
    }
  }
  public sendMessage() {
    this._appData.talkTo = this.user;
    this._appData.cellScreen = 'chat'
    this._appData.toggleCellPhone = true;
    $('#userInteractionModal').modal('hide')
    setTimeout(() => {
      $('#cellChatReload').click()
    }, 1000)


  }
  public videoConference() {
    Swal.fire({
      title: "Chamada por vídeo",
      text: "Você deseja convidar esse usuário para falar contigo por videoconferência?",
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      showCancelButton: true,
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null, this._appData.instagramUser, this.user, "Pedido de videoconferência", this._appData.instagramUser.full_name + " está te convidando para ir para conversar por videoconferência. Você aceita?", "newCellJitsi", "", false)
        $('#userInteractionModal').modal('hide')
        Swal.fire({
          title: 'Convite enviado',
          message: this.user.full_name + ' foi convidado para conversar contigo. Aguarde resposta.'
        });
      }
    });
  }

  public yoink() {
    Swal.fire({
      title: this.translate.instant('CONTACT_SCREEN_COMPONENT_12'),
      text: this.translate.instant('CONTACT_SCREEN_COMPONENT_11') + this.user.full_name + this.translate.instant('CONTACT_SCREEN_COMPONENT_9'),
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText: this.translate.instant('NO'),
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => {
        this._companyService.sendNotificationToSomeoneElse(this._appData.event, this._appData.instagramUser, this.user, 'Yoink', this._appData.instagramUser.full_name + ' chamou sua atenção.', 'Yoink', 0, null)
      }

    })
  }
  public goto() {
    Swal.fire({
      title: "TELEPORTE",
      text: "Você deseja convidar esse usuário a se teleportar para onde você está?",
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      showCancelButton: true,
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.sendNotificationToSomeoneElse(null, this._appData.instagramUser, this.user, "Pedido de teleporte", this._appData.instagramUser.full_name + " está te convidando para ir para o evento onde está. Você deseja ir?", "newCellTeleport", this._appData.room.id, false)
        Swal.fire({
          title: 'Convite enviado',
          message: this.user.full_name + ' foi convidado para se teleportar para onde você se encontra. Aguarde resposta.'
        });
      }
    });
  }
  public change() {
    this.user = this._appData.friendOnEvent;
    if (this.user.uid < 0) {
      this.canAskContact = false;
      this.canChat = true;
      this.canVideo = false;
      this.canKick = true;
      return;
    }

    this._companyService.getUserByUid(this.user.uid).then(val => {
      let us = val.data();
      if (us) {
        this.user = us;
        let date = this.user.birthdate;
        if (date) {
          let currentDate = new Date();
          let birthdate = new Date(date);
          let age = currentDate.getFullYear() - birthdate.getFullYear();
          const month = currentDate.getMonth() - birthdate.getMonth();
          if (month < 0 || (month === 0 && currentDate.getDate() < birthdate.getDate())) {
            age--;
          }
          this.user.age = age;
        }
      } else {
        return;
      }
    });

    this.images = [];

    let galleryReference = this._companyService.getUserGallery(this.user);
    galleryReference.on("child_added", (snapshot, prevChildKey) => {
      let date = new Date();
      let myImages = this.images;
      if (!myImages) myImages = [];
      let message = snapshot.val();
      let milis = date.getTime() - 10 * 60 * 1000;
      this.images.unshift(message);
    });

    if (this._appData.instagramUser.company === this.user.company) {

      this.canAskContact = false;
      this.canChat = true;
      this.canVideo = false;
      this.canKick = false;
    } else {

      this.canAskContact = true;
      this.canChat = false;
      this.canVideo = false;
      this.canKick = false;
    }

    this.hasKey = false;
    if (this._appData.admin) {
      this.hasKey = true;
      return;
    }
    let key = this._appData.room.key;
    if (key) {
      let filt = this._appData.userEventContainer.filter(val => {
        return key === val.name;
      });
      this.hasKey = filt.length > 0;
    }
  }


  constructor(public translate: TranslationService, public _appData: AppDataService, private _companyService: CompanyService) {
  }


  public sendIframeMessage(messageKind) {
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/user-interaction-modal/user-interaction-modal.ts